<template>
  <div class="d-sm-flex align-items-center justify-content-between mb-4">
    <div><h4 class="main-title mb-0">{{ text }}</h4></div>
  </div>
</template>

<script>
export default {
  name: "title block",
  props: {
    text: {
      type: String,
      default: "props :text='Тут загаловок'",
    },
  },
};
</script>

<style>
</style>